import React, { useEffect, useCallback, useState} from 'react';
import {ZOBJECT} from 'constants/object-types.js';
import {useMintToHic} from 'components/hooks/useMintToHic.js';
import {useMintToZora} from 'components/hooks/useMintToZora.js';
import {setViewableSubPatches} from 'actions/index.js';
import {
    savePreset,
} from 'components/v2/trackRightClickActions.js';
import {
    setZObjectsStack,
    setZObjectBackground,
    setPluginToSave,
    setUXLockObject,
    setWindowPosition,
    setZObjectInputText,
    setFullScreenZObject,
    setSelectedZObject,
    setSelectedPulledElements} from 'actions/index.js';
import SubMenu from "components/dropdowns/SubMenu.js";
import {
    setZObjectContextMenu} from 'actions/index.js';
import ContextMenu from "components/dropdowns/ContextMenu.js"
import MenuItem from "components/dropdowns/MenuItem.js";
import {connect} from 'react-redux';
import './context-menu.scss';

const ZObjectContextMenus = ({
    setZObjectsStack,
    setZObjectBackground,
    setPluginToSave,
    setUXLockObject,
    setZObjectInputText,
    setFullScreenZObject,
    setSelectedPulledElements,
    setSelectedZObject,
    contextMenu,
    setLocked,
    isLocked,
    setViewableSubPatches,
    clear
}) => { 
   if (!contextMenu) {
        return '';
    }
    let {zobject, position} = contextMenu;

    useEffect(() => {
        if (contextMenu) {
            setSelectedZObject(contextMenu.zobject);
        }
    }, [contextMenu]);

    const {mintToHic} = useMintToHic({
        zobject,
        setDropdownPos: clear
    });
    const {mintToZora} = useMintToZora({
        zobject,
        setDropdownPos: clear
    });
    
    const duplicate = useCallback(() => {
        zobject.duplicate();
        clear();
    }, []);

    const toggleLock = useCallback(() => {
        setLocked(!isLocked);
    }, [isLocked]);

    const openSubPatch = useCallback(() => {
        let _zobject = zobject;
        if (zobject.pluginViewerFor) {
            _zobject = zobject.pluginViewerFor;
        }
        let spatches = _zobject.sequencerEngine.state.zobject.viewableSubPatches;
        if (_zobject.subSequence && _zobject.subSequence.zObject) {
            _zobject.effect.width = _zobject.subSequence.width;
            _zobject.effect.height = _zobject.subSequence.height;
            
            let windowPosition = zobject.sequencerEngine.state.windows.windowPositions[
                zobject.subSequence.id];
            zobject.sequencerEngine.dispatch(setWindowPosition(
                _zobject.effect.id,
                windowPosition));
        }
        setViewableSubPatches(
            [... spatches, _zobject.effect]);
    }, [zobject]);


    const includeObjectInPresentation = useCallback(() => {
        let include = zobject.attributes["Include in Presentation"] === true;
        zobject.setAttribute("Include in Presentation", !include);
    }, [zobject]);

    const fullScreen = useCallback(() => {
        setFullScreenZObject(zobject);
        setSelectedZObject(undefined);
        clear();
    }, [zobject]);

    const deleteZObject = useCallback(() => {
        zobject.delete();
    }, [zobject]);

    const createPlugin = useCallback(() => {
        setPluginToSave(zobject);
    }, [zobject]);

    const updatePlugin = useCallback(() => {
        setPluginToSave(zobject.pluginViewerFor || zobject.plugin);
    }, [zobject]);

    const saveAsPreset = useCallback(() => {
        setSelectedZObject(zobject);
        savePreset(zobject);
    }, [zobject]);

    return (
        <ContextMenu
          className="zobject-context-menu"
          dropdownPos={position} setDropdownPos={clear}>
          <MenuItem onMouseDown={fullScreen}>
            Fullscreen 
            <div className="key-shortcut"><img src="/expand-icon.svg"/></div>
          </MenuItem>
          <MenuItem onMouseDown={includeObjectInPresentation}>
            {zobject.attributes["Include in Presentation"] ? "Remove from Presentation" : "Include in Presentation"} <div className="key-shortcut"><img src="/presentation-mode.svg"/></div>
          </MenuItem>
          {/*<MenuItem onMouseDown={() => setZObjectBackground(zobject)}>
             Set As Background
             </MenuItem>*/}
          {(zobject.name === "subpatch" || zobject.pluginViewerFor) && <MenuItem onMouseDown={openSubPatch}>
                                                                         Open Subpatch Editor
                                                                       </MenuItem>}
          <MenuItem onMouseDown={duplicate}>
            Duplicate <div className="key-shortcut">⌘D</div>
          </MenuItem>
          <MenuItem onMouseDown={toggleLock}>
            {isLocked ? "Unlock" : "Lock"}
          </MenuItem>
          <div className="divider"/>
          <MenuItem onMouseDown={saveAsPreset}>
            Save as Preset
          </MenuItem>
          {zobject.getObjectType() === ZOBJECT &&
           (zobject.plugin || zobject.pluginViewerFor ?
            <MenuItem onMouseDown={updatePlugin}>
              Update Plugin
            </MenuItem> :
            <MenuItem onMouseDown={createPlugin}>
              Create Plugin
            </MenuItem>)}
          {zobject.getObjectType() === ZOBJECT &&
           <SubMenu name="Mint On...">
             <MenuItem onMouseDown={mintToZora}>
               Zora
             </MenuItem>
             <MenuItem onMouseDown={mintToHic}>
               Hicetnunc/Objkt
             </MenuItem>
           </SubMenu>}
          <MenuItem onMouseDown={deleteZObject}>
            Delete
          </MenuItem>
          <div className="divider"/>
          {zobject.actions && Object.keys(zobject.actions).map(
              x => <MenuItem onMouseDown={() => {
                  zobject.executeAction(x);
                  clear();
              }}>{x}</MenuItem>)}
        </ContextMenu>);
};

const mapStateToProps = (state, props) => {
    let contextMenu = state.zobject.contextMenu[props.subSequence.id]
  return {
      isLocked: contextMenu && state.spatial.lockedObjects[contextMenu.zobject.id],
      contextMenu
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      clear : x => dispatch(setZObjectContextMenu(x)),
      setViewableSubPatches: x => dispatch(setViewableSubPatches(x)),
      setSelectedPulledElements: x => dispatch(setSelectedPulledElements(x)),
      setSelectedZObject : x => dispatch(setSelectedZObject(x)),
      setFullScreenZObject: x => dispatch(setFullScreenZObject(x)),
      setZObjectInputText: x => dispatch(setZObjectInputText(x)),
      setLocked: (id, x) => dispatch(setUXLockObject(id, x)),
      setPluginToSave: x => dispatch(setPluginToSave(x)),
      setZObjectBackground: x=> dispatch(setZObjectBackground(x)),
      setZObjectsStack: x=> dispatch(setZObjectsStack(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZObjectContextMenus);
